import axios from 'axios';

// const client = axios.create({
//     baseURL: 'http://localhost:8000', // Adjust if backend runs elsewhere
// });

const client = axios.create({
    baseURL: process.env.REACT_APP_API_URL || 'http://localhost:8000',
});


// Add a request interceptor to include the auth token
client.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export default client;
